// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"MainLoader_loaderContainer__1UeYu","suspense":"MainLoader_suspense__3bTlP"};